import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import i18n from '@/i18n'

interface UIState {
  language: string
  isNavToggle: boolean
  showKline: boolean
  klineTimeTypeActive: string
  readID: number
  unRead: boolean
  setLanguage: (lang: string) => void
  setNavToggle: (value: boolean) => void
  setShowKline: (value: boolean) => void
  setKlineTimeTypeActive: (value: string) => void
  setReadID: (id: number) => void
  setUnRead: (value: boolean) => void
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      language: localStorage.getItem('language') || 'en',
      isNavToggle: false,
      showKline: true,
      klineTimeTypeActive: 'hour',
      readID: 0,
      unRead: false,
      setLanguage: (lang) => {
        i18n.changeLanguage(lang)
        set({ language: lang })
      },
      setNavToggle: (value) => set({ isNavToggle: value }),
      setShowKline: (value) => set({ showKline: value }),
      setKlineTimeTypeActive: (value) => set({ klineTimeTypeActive: value }),
      setReadID: (id) => set({ readID: id }),
      setUnRead: (value) => set({ unRead: value }),
    }),
    { name: 'totoro-ui' },
  ),
)
